import React from 'react';
import { ShIntlMessageDefinition, ShText } from '@shoootin/translations';
import { AppSEOImage } from '../../appSEO';
import { AppGatsbyImage, AppGatsbyImageFluid } from '../../primitives/appImage';

export type HeroCoverValues = {
  h2: ShIntlMessageDefinition;
  p: ShIntlMessageDefinition;
};

const HeroCover = ({
  image,
  values,
}: {
  image: AppGatsbyImageFluid;
  values: HeroCoverValues;
}) => (
  <>
    <AppSEOImage image={image.src!} />
    <div className="hero hero--cover">
      <AppGatsbyImage
        fluid={image}
        className="hero-background"
        style={{ position: 'absolute' }}
      />
      <div className="container hero-caption">
        <h2 className="hero-title title">
          <ShText message={values.h2} />
        </h2>
        <p className="hero-text text-intro">
          <ShText message={values.p} />
        </p>
      </div>
    </div>
  </>
);

export default HeroCover;
